// Equation icons rendered in GM font (Kalam) with HTML math styling
const EQ_ICON = (html) => `<span class="eq-card-icon">${html}</span>`;
const FRAC = (num, den) =>
  `<span class="eq-frac"><span class="eq-frac-num">${num}</span><span class="eq-frac-den">${den}</span></span>`;

new GuidedTopics.EquationSolverPage({
  pageId: 'one-step-equations',
  title: 'One-Step Equations',
  guideUrl: 'one-step-equations-guide.html',
  presets: {
    'preset-addition': {
      id: 'preset-addition',
      name: 'Addition',
      icon: EQ_ICON('<i>x</i> + 5 = 12'),
      expressions: [],
      equations: ['x + 5 = 12'],
    },
    'preset-subtraction': {
      id: 'preset-subtraction',
      name: 'Subtraction',
      icon: EQ_ICON('<i>x</i> − 3 = 8'),
      expressions: [],
      equations: ['x - 3 = 8'],
    },
    'preset-multiplication': {
      id: 'preset-multiplication',
      name: 'Multiplication',
      icon: EQ_ICON('3<i>x</i> = 15'),
      expressions: [],
      equations: ['3x = 15'],
    },
    'preset-division': {
      id: 'preset-division',
      name: 'Division',
      icon: EQ_ICON(FRAC('<i>x</i>', '4') + ' = 3'),
      expressions: [],
      equations: ['x/4 = 3'],
    },
    'preset-challenge': {
      id: 'preset-challenge',
      name: 'Addition',
      icon: EQ_ICON('<i>x</i> + 15 = 7'),
      expressions: [],
      equations: ['x + 15 = 7'],
    },
    'preset-right-add': {
      id: 'preset-right-add',
      name: 'Variable on Right',
      icon: EQ_ICON('12 = <i>x</i> + 5'),
      expressions: [],
      equations: ['12 = x + 5'],
    },
    'preset-right-mul': {
      id: 'preset-right-mul',
      name: 'Variable on Right',
      icon: EQ_ICON('15 = 3<i>x</i>'),
      expressions: [],
      equations: ['15 = 3x'],
    },
  },
  wizard: {
    title: 'Create One-Step Equation',
    subtitle: 'Choose the type of equation:',
    typeCards: {
      addition: {
        name: 'Addition',
        icon: 'x + a = b',
        examples: ['x + 5 = 12', 'x + 3 = 10'],
      },
      subtraction: {
        name: 'Subtraction',
        icon: 'x \u2212 a = b',
        examples: ['x \u2212 3 = 8', 'x \u2212 7 = 2'],
      },
      multiplication: {
        name: 'Multiplication',
        icon: 'ax = b',
        examples: ['3x = 15', '5x = 20'],
      },
      division: { name: 'Division', icon: 'x/a = b', examples: ['x/4 = 3', 'x/6 = 2'] },
    },
    typeOrder: ['addition', 'subtraction', 'multiplication', 'division'],
    entryTemplates: {
      addition: {
        expression: 'x + \\numberbox = \\numberbox',
        slots: [
          {
            id: 'constant',
            label: 'number to add',
            type: 'integer',
            allowNegative: false,
          },
          { id: 'result', label: 'result', type: 'integer', allowNegative: true },
        ],
      },
      subtraction: {
        expression: 'x - \\numberbox = \\numberbox',
        slots: [
          {
            id: 'constant',
            label: 'number to subtract',
            type: 'integer',
            allowNegative: false,
          },
          { id: 'result', label: 'result', type: 'integer', allowNegative: true },
        ],
      },
      multiplication: {
        expression: '\\numberbox x = \\numberbox',
        slots: [
          {
            id: 'coefficient',
            label: 'coefficient',
            type: 'integer',
            allowNegative: false,
            exclude: [0, 1],
          },
          { id: 'result', label: 'result', type: 'integer', allowNegative: true },
        ],
      },
      division: {
        expression: 'x / \\numberbox = \\numberbox',
        slots: [
          {
            id: 'divisor',
            label: 'divisor',
            type: 'integer',
            allowNegative: false,
            exclude: [0],
          },
          { id: 'result', label: 'result', type: 'integer', allowNegative: true },
        ],
      },
    },
    buildEquation: (type, values) => {
      switch (type) {
        case 'addition':
          return `x + ${values.constant} = ${values.result}`;
        case 'subtraction':
          return `x - ${values.constant} = ${values.result}`;
        case 'multiplication':
          return `${values.coefficient}x = ${values.result}`;
        case 'division':
          return `x / ${values.divisor} = ${values.result}`;
        default:
          return 'x = 0';
      }
    },
  },
}).init();

// StartChooser handles its own onboarding ("choose a problem" arrow).
// No additional showOnboardingArrows() needed here.
